import { defineNuxtPlugin } from '#app';

export default defineNuxtPlugin((nuxtApp) => {

	let userCountry = "US"  

	if(nuxtApp.$i18n && nuxtApp.$i18n.locale.value === 'in' ){
		userCountry = 'IN'
	}

	if (nuxtApp.$i18n && nuxtApp.$i18n.locale.value === "uk") {
		userCountry = "UK";
	}

	//set gloabal variable for payment 
	const country = {
	//for alternate tag start
	pathSegment: "/in",
	language: "en-IN",
	currency_sign: "USD",
	//for alternate tag end

	location: "US",
	is_india: false,
	is_uk: false,
	full_country_list: true,

	currency_usd: true,

	paymentFlag: {
		credit_card: true,
		affirm: true,
		affirmStripe: true,
		klarnaStripe: true,
		googlepayStripe: true,
		paypal: true,
		paylater: false,
		telephone: true,
		ach: true,
		splitit: false,
		bankwire: true,
		juspay: false,
		afterpay: false,
		googlepay: true,
		applepay: true,
		stripe: false,
	},
	affirm: true,
	accrue: true,
	evertreen: true,
	appraisal: true,
	payment_banner: true,
	office_appointment: true,

	mobile: "+1 646 9564572",
	email: "customerservice@friendlydiamonds.com",

	dollar_icon: true,

	estimate_msg: "Estimated date of shipment:",

	trustpilot: true,
	bbb: true,
	footer_pay_icons: true,
	coupon: true,
	returnPeriod: 30,
	expedite: false,
	cleaningKit : true,
	addressLine:
		"Please provide an address where someone 18 or older can accept and sign for the delivery. Unfortunately, we are unable to ship to P.O. boxes, APOs, and FPOs.",
	instagramHandle: "https://www.instagram.com/friendly.diamonds",
	address : "Friendly Diamonds Inc, 551 5th Avenue, 31st Floor, New York, NY 10176, United States",
	free_product: true,
	tawkurl: 'https://embed.tawk.to/5ea2ea2369e9320caac6f331/default'
	};


	if ( userCountry === "UK" ) {
		country.pathSegment = ""
		country.language = "en-GB"
		country.currency_sign = "GBP"
		country.location = "UK"
		country.currency_usd = false
		country.is_uk = true
		country.full_country_list = false,

		country.paymentFlag.credit_card = false
		country.paymentFlag.affirm = false
		country.paymentFlag.affirmStripe = false
		country.paymentFlag.klarnaStripe = true
		country.paymentFlag.googlepayStripe = true
		country.paymentFlag.paypal = false
		country.paymentFlag.paylater = false
		country.paymentFlag.telephone = true
		country.paymentFlag.ach = false
		country.paymentFlag.splitit = false
		country.paymentFlag.bankwire = false
		country.paymentFlag.juspay = false
		country.paymentFlag.afterpay = false
		country.paymentFlag.googlepay = false
		country.paymentFlag.applepay = false
		country.paymentFlag.stripe = true


		country.affirm = false
		country.accrue = false
		country.evertreen = true
		country.appraisal = false
		country.payment_banner = true
		country.office_appointment = false

		country.mobile =  "+44 7488894804",
		country.email = "uk.customerservice@friendlydiamonds.com"

		country.dollar_icon = false;

		country.estimate_msg = "Estimated date of shipment:";

		country.trustpilot = true
		country.bbb = false
		country.footer_pay_icons = true
		country.cleaningKit = false,
		country.returnPeriod = 30,
		country.coupon = true
		country.expedite = false
		country.addressLine = 'Please provide an address where someone 18 or older can accept and sign for the delivery.'
		country.instagramHandle = 'https://www.instagram.com/friendlydiamondsuk/?utm_source=ig_web_button_share_sheet'
		country.address = "Kenilworth rd, Balsall Common, Coventry. CV7 7HD"

		country.free_product = true;
		country.tawkurl = 'https://embed.tawk.to/685a76d0e55290190adec45e/1iugm085m'
	}

	//enable/disable payment gateways as per current country
	if( userCountry === 'IN' ){

		//for alternate tag start
		country.pathSegment = '',
		country.language = 'en-US',
		country.currency_sign = 'INR',
		//for alternate tag end

		country.location = 'IN',

		country.is_india = true,
		country.full_country_list = false,

		country.currency_usd = false,
		
		country.paymentFlag.credit_card = false
		country.paymentFlag.affirm = false
		country.paymentFlag.paypal = false
		country.paymentFlag.paylater = false
		country.paymentFlag.telephone = true
		country.paymentFlag.ach = false
		country.paymentFlag.splitit = false
		country.paymentFlag.bankwire = false
		country.paymentFlag.juspay = true
		country.paymentFlag.afterpay = false
		country.paymentFlag.googlepay = false
		country.paymentFlag.applepay = false

		country.affirm = false
		country.accrue = false
		country.evertreen = false
		country.appraisal = false
		country.payment_banner = false
		country.office_appointment = false

		country.mobile =  "+91 9920987654",
		country.email = "india@friendlydiamonds.com"

		country.dollar_icon = false

		country.estimate_msg = 'Estimated date of delivery:'

		country.trustpilot = false
		country.bbb = false
		country.footer_pay_icons = false

		country.returnPeriod = 15,
		country.cleaningKit = false,
		country.coupon = true
		country.expedite = false
		country.addressLine = 'Please provide an address where someone 18 or older can accept and sign for the delivery.'
		country.instagramHandle = 'https://www.instagram.com/friendlydiamondsin/'
		country.address = "Ground Floor,1-8 Salasar Estate,\n Yadav Nagar, Dahisar East\nMumbai, Maharashtra - 400068 (India)";

		country.free_product = false
		country.tawkurl = false
	}

		nuxtApp.provide('country', country);

});
